<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card min-height">
      <div class="card-body">
        <TableLoading v-if="users.page === 0"/>
        <div v-else>
          <staff-table :rows="users" :perPage="perPage" :current-page="currentPage" @onSearch="searchFn"/>
          <b-pagination
              v-model="currentPage"
              :total-rows="users.total"
              :per-page="perPage"
              size="lg"
              align="center"
          />
          </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import PageHeader from "@/components/page-header";
import {SYSTEM_USERS} from "@/gql";
import StaffTable from "@/components/staff/staff-table";
import TableLoading from "@/components/TableLoading";

export default {
  page: {
    title: "System User",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {TableLoading, StaffTable, PageHeader, Layout},
  name: "staff",
  data() {
    return {
      title: "System User",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "System User",
          active: true
        }
      ],
      users: {
        page: 0,
        objects: []
      },
      currentPage: 1,
      perPage: 30,
      searchKeyword: "",
      system_users: SYSTEM_USERS,
    }
  },
  apollo: {
    users: {
      query: SYSTEM_USERS,
      variables(){
        return {
          page: this.currentPage,
          perPage: 30,
          searchKeyword: this.searchKeyword
        }
      }
    }
  },
  watch: {
    currentPage(){
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  },
  mounted() {
    this.currentPage = parseInt(this.$route.query.page) || 1
  },
  methods: {
    searchFn(data){
      this.searchKeyword = data
    },
  }
}
</script>

<style scoped>

</style>
